export enum AlarmZoneType {
    MotionDetection = "MotionDetection",
    LoiteringDetection = "LoiteringDetection",
    RailDefender = "RailDefender",
    ViolentBehaviorDetection = "ViolentBehaviorDetection",
    UnattendedObjectDetection = "UnattendedObjectDetection",
    FallDetection = "FallDetection",
}
